export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
                  <i className="ri-movie-2-line text-xl"></i>
                </span>
                <span className="text-background-50 font-heading font-bold text-xl">
                  蘑菇影院
                </span>
              </div>
              <p className="text-background-300 text-sm leading-relaxed max-w-md mb-4">
                蘑菇影院致力于为广大影迷提供免费电影在线观看和免费电视剧全集资源。我们每日更新全网最新热门影视，高清画质不缓冲，让您随时随地畅享免费在线观看体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-all duration-200 cursor-pointer">
                  <i className="ri-home-4-line"></i>
                </a>
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 hover:bg-primary-500 text-background-200 hover:text-background-50 transition-all duration-200 cursor-pointer">
                  <i className="ri-mail-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold text-sm mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><a href="#about" className="text-background-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">关于我们</a></li>
                <li><a href="#cards" className="text-background-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">热门推荐</a></li>
                <li><a href="#ranking" className="text-background-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">影视热榜</a></li>
                <li><a href="#index" className="text-background-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">专题合集</a></li>
                <li><a href="#faq" className="text-background-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">常见问题</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold text-sm mb-4">合作伙伴</h4>
              <p className="text-background-400 text-sm">暂无合作伙伴信息</p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-400 text-xs">
              &copy; {new Date().getFullYear()} 蘑菇影院 - 免费电影在线观看 | 免费电视剧全集高清不缓冲免费看
            </p>
            <p className="text-background-500 text-xs">
              本站内容仅供学习交流，请支持正版
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}